import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";

/**
 * Компонент который рендерит meta-теги для страницы с контентом
 */
export default function EmbedHelmet({ content }) {
  if (!content) return null;

  const desc = content.rightholder.name;

  return (
    <Helmet>
      <title>{content.title}</title>

      <meta name="twitter:title" content={content.title} />
      <meta property="og:title" content={content.title} />

      <meta name="description" content={desc} />
      <meta property="og:description" content={desc} />
      <meta name="twitter:description" content={desc} />

      <meta property="og:type" content="video.other" />

      <meta property="og:url" content={content.url} />

      <meta property="twitter:player" content={content.url} />
      <meta property="twitter:player:width" content="1280" />
      <meta property="twitter:player:height" content="720" />

      {content.preview && (
        <meta property="og:image" content={content.preview} />
      )}
      {content.preview && <link rel="image_src" href={content.preview} />}
      {content.preview && (
        <meta name="twitter:image" content={content.preview} />
      )}

      <meta name="twitter:card" content="summary_large_image" />

      <link rel="canonical" href={content.shareUrl} />
    </Helmet>
  );
}

EmbedHelmet.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    shareUrl: PropTypes.string,
    description: PropTypes.string,
    preview: PropTypes.string,
    rightholder: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }),
};
